import type { Campaign } from './data';

export type Dashboard = 'deals' | 'vendor' | 'vendor-current' | 'pcm' | 'pcm-current';
export type Selection = {
  dashboard: Dashboard;
  room?: string;
  measure?: string;
  currency?: string;
  scope?: 'dashboard' | 'lead';
};
export type Action =
  | { type: 'room' | 'measure' | 'currency'; value: string; scope?: 'dashboard' | 'lead'; measure?: string }
  | { type: 'clear' };
export const EMPTY_SELECTION: Selection = { dashboard: 'vendor' };

/** Current workbook's six brush actions preserve the underlying values. Only the
 * Deal Selection currency action is a filter; all seven have auto-clear=true. */
export function selectMark(state: Selection, dashboard: Dashboard, action: Action): Selection {
  const current = state.dashboard === dashboard ? state : { dashboard };
  if (action.type === 'clear') return { dashboard };
  if (action.type === 'currency') {
    if (dashboard !== 'deals') return current;
    return { ...current, currency: current.currency === action.value ? undefined : action.value };
  }
  if (action.type === 'room' && !['vendor', 'vendor-current'].includes(dashboard)) return current;
  if (action.type === 'measure' && (dashboard === 'deals' || (dashboard === 'vendor' && action.scope !== 'lead')))
    return current;
  const toggledOff =
    current[action.type] === action.value && (current.scope || 'dashboard') === (action.scope || 'dashboard');
  if (toggledOff) return { dashboard };
  return {
    dashboard,
    scope: action.scope || 'dashboard',
    [action.type]: action.value,
    ...(action.type === 'room' && dashboard === 'vendor-current' ? { measure: action.measure } : {}),
  };
}
export function markOpacity(
  state: Selection,
  dashboard: Dashboard,
  fields: { room?: string; measure?: string },
  scope: 'dashboard' | 'lead' = 'dashboard',
): number {
  if (state.dashboard !== dashboard || (state.scope || 'dashboard') !== scope) return 1;
  if (state.room && fields.room !== undefined && state.room !== fields.room) return 0.3;
  if (state.measure && fields.measure !== undefined && state.measure !== fields.measure) return 0.3;
  return 1;
}
export function selectionOffers(campaigns: Campaign[], selection: Selection, currencyMode: string): Campaign[] {
  if (selection.dashboard !== 'deals' || !selection.currency) return campaigns;
  // Source Vendor Currency expression is cost_currency, or the literal AUD.
  return campaigns.filter((c) =>
    currencyMode === 'AUD' ? selection.currency === 'AUD' : c.vendor_currencies?.includes(selection.currency),
  );
}
